import { useEffect, useState } from 'react';
import { ArrowUpRight, Menu } from 'lucide-react';
import Logo from './Logo';
import AnchorLink from './AnchorLink';
import MobileMenu from './MobileMenu';
import { NAV } from '../content/site';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header className={`sticky top-0 z-50 border-b-2 border-ink transition-colors ${scrolled ? 'bg-bg/[0.88] backdrop-blur-[12px]' : 'bg-bg'}`}>
        <div className="container-site flex h-header items-center gap-8">
          <Logo className="mr-auto" />
          <nav aria-label="Primary" className="hidden items-center gap-8 text-[15px] font-semibold nav:flex">
            {NAV.map(n => (
              <AnchorLink key={n.href} href={n.href} className="transition-colors hover:text-accent">{n.label}</AnchorLink>
            ))}
          </nav>
          <AnchorLink href="#contact" className="hidden h-11 items-center gap-2.5 bg-accent px-[18px] text-[15px] font-extrabold text-bg transition-colors hover:bg-accent-600 nav:inline-flex">
            Book a call <ArrowUpRight size={16} aria-hidden="true" />
          </AnchorLink>
          <button type="button" onClick={() => setMenuOpen(true)} aria-expanded={menuOpen} aria-label="Open menu" className="grid h-11 w-11 place-items-center bg-ink text-bg nav:hidden">
            <Menu size={20} aria-hidden="true" />
          </button>
        </div>
      </header>
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
